import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from './store'
import 'amfe-flexible';
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

window.wx = require('weixin-js-sdk')

// 网易云信SDK相关
// 播放器在 index.html 中引入
// 网易云信SDK 在 src/store/modules/im.js 中引入


// session 缓存
import { session, removeSession, local, removeLocal } from '@/utils/session'
Vue.prototype.session = session;
Vue.prototype.removeSession = removeSession;
Vue.prototype.local = local;
Vue.prototype.removeLocal = removeLocal;

local('origin', window.location.origin)
//云信appkey
// local('nimAppKey', 'b0bb4b36ef49e4096948bed7302a5d47');

Vue.config.productionTip = false

// 小数格式化
import { filterMoney, filterCoin, filter2, filter4, dataFormat } from '@/utils/filter'
Vue.filter('filter2', filter2)
Vue.filter('filter4', filter4)
Vue.filter('filterMoney', filterMoney)
Vue.filter('filterCoin', filterCoin)
Vue.filter('dataFormat', dataFormat)

// 共用方法
import {
  formatSeconds,
  knowledgeTypeName,
  appDownload,
  showImagePreview,
  $numAdd,
  $numSub,
  $numMulti,
  $numDiv,
  checkQiNiuUrl,
  replaceHttp2Https,
  randomNum,
} from '@/utils/common'

Vue.prototype.formatSeconds = formatSeconds; // 课程时长时长
Vue.prototype.knowledgeTypeName = knowledgeTypeName; // 课程类型 class 名
Vue.prototype.appDownload = appDownload; // 弹出提示框下载APP
Vue.prototype.showImagePreview = showImagePreview; // 全屏预览图片
Vue.prototype.$numAdd = $numAdd;
Vue.prototype.$numSub = $numSub;
Vue.prototype.$numMulti = $numMulti;
Vue.prototype.$numDiv = $numDiv;
Vue.prototype.checkQiNiuUrl = checkQiNiuUrl;
Vue.prototype.replaceHttp2Https = replaceHttp2Https;
Vue.prototype.randomNum = randomNum;

Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};


//点击复制插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//判断是否为微信浏览器
function isWechatOpen(){
  let ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger')>0;
}

//截取url参数
function parseQueryString(url) {
  var params = {};
  var arr = url.split("?");
  if (arr.length <= 1) {
    return params;
  }
  arr = arr[1].split("&");
  for(var i = 0, l = arr.length; i < l; i++) {
    var a = arr[i].split("=");
    params[a[0]] = a[1];
  }
  return params;
}

// if(!session('token')){
//   //外网
//   let publicData = {"user":{"userOpenId":"1990595","token":"eyJhcHBJZCI6ImFudHRhbGsiLCJjbGllbnRUeXBlR3JvdXAiOiJ3YXBXWCIsImFsZyI6IkhTNTEyIn0.eyJzdWIiOiIxOTkwNTk1IiwiZXhwIjoxNjM0NzIyNTk5fQ.gzIt8019KBDBK4ZuLeEy7XPDZb9qdF337rP9VhVvMMOMGtDrb9qieSPJOXgmeVF388IQgxqy6duxWoNJLzTj-Q","username":"18578619930","phone":"18578619930","avatar":"https://fileqn.anttalk.vip/2018/06/28/f18e4725-51d3-455e-bb0e-0e3f6cafc0b9.jpg","name":"呵呵","nickname":"大神","sex":1,"fileServerDomain":"https://fileqn.anttalk.vip/","inviteCode":"20CD","inviteCodeOnLevel1":"5188","registerInviteCode":"5188","snapCode":null,"id":"103"},"userOpenId":"1990595","token":"eyJhcHBJZCI6ImFudHRhbGsiLCJjbGllbnRUeXBlR3JvdXAiOiJ3YXBXWCIsImFsZyI6IkhTNTEyIn0.eyJzdWIiOiIxOTkwNTk1IiwiZXhwIjoxNjM0NzIyNTk5fQ.gzIt8019KBDBK4ZuLeEy7XPDZb9qdF337rP9VhVvMMOMGtDrb9qieSPJOXgmeVF388IQgxqy6duxWoNJLzTj-Q","userInfo":{"openid":"1990595","username":"18578619930","nickname":"大神","sex":1,"avatar":"https://fileqn.anttalk.vip/2018/06/28/f18e4725-51d3-455e-bb0e-0e3f6cafc0b9.jpg","phone":"18578619930","birthday":"1989-12-31T16:00:00.000+0000","sign":null,"switchType":true,"inviteCode":"20CD","inviteCodeOnLevel1":"5188","payPassword":"1"}}
//     // 内网
//   // let publicData = {"user":{"userOpenId":"8850444541493248","token":"eyJhcHBJZCI6ImFudHRhbGsiLCJjbGllbnRUeXBlR3JvdXAiOiJ3YXBXWCIsImFsZyI6IkhTNTEyIn0.eyJzdWIiOiI4ODUwNDQ0NTQxNDkzMjQ4IiwiZXhwIjoxNjE0NjU0MDA5fQ.4QVX24oFcH1oJjCFbrnYMHRNjhUcDDnI8K5KuAUdBZRZh-0WxO1J0903KAC8Xhmw35xk7Xw1A15u1NpDHK7xPw","username":"anttalk_cfbfadd2","phone":"13600000003","avatar":"https://fileqn.anttalk.vip/icon-320.png","name":"隔壁老王","nickname":"003","sex":0,"fileServerDomain":"https://fileqn.anttalk.vip/","inviteCode":"KPXYUB","inviteCodeOnLevel1":"0608","registerInviteCode":"0608","snapCode":null,"id":null},"userOpenId":"8850444541493248","token":"eyJhcHBJZCI6ImFudHRhbGsiLCJjbGllbnRUeXBlR3JvdXAiOiJ3YXBXWCIsImFsZyI6IkhTNTEyIn0.eyJzdWIiOiI4ODUwNDQ0NTQxNDkzMjQ4IiwiZXhwIjoxNjE0NjU0MDA5fQ.4QVX24oFcH1oJjCFbrnYMHRNjhUcDDnI8K5KuAUdBZRZh-0WxO1J0903KAC8Xhmw35xk7Xw1A15u1NpDHK7xPw"}
//   console.log(publicData)
//   sessionStorage.setItem('public', JSON.stringify(publicData))
// }



// 路由
router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  title && (document.title=title);
  local('currentUrl', document.URL) // 当前url

  // 用于区分不同的公众号，默认可不传值为1，
  if(document.URL.indexOf('wxCase')>0){
   let query =  parseQueryString(document.URL)
    query.wxCase && session('wxCase',(query.wxCase-0))
  }

  let token = session('token') || '';
  if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
    if (token) { // 查询本地存储信息是否已经登陆
      next();
    } else {
      console.log(to)
      console.log(to.fullPath)
      local('beforeLoginQuery', to.query)
      local('beforeLoginUrl', to.fullPath)
      let path = isWechatOpen() ? '/loginBefore' : '/loginPhone';
      // let path = '/loginBefore';
      next({
        path, // 未登录则跳转至login页面
        // query: {redirect: to.fullPath} // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
      });
    }
  } else {
    next();
  }
});

window.vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
